import { render, staticRenderFns } from "./ChildrenHorizontalLine.vue?vue&type=template&id=2541f0bc&"
import script from "./ChildrenHorizontalLine.vue?vue&type=script&lang=js&"
export * from "./ChildrenHorizontalLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports